import { BoxProps, Text, TextProps } from '@chakra-ui/react'
import { ScalarContentNode } from '@helo/cms'
import { merge } from 'lodash'

import { ConditionalLink } from '../../components/Link/Link'
import { InlineSkeleton } from '../../components/SkeletonLoader'
import { ConditionalTooltip } from '../../components/Tooltip/Tooltip'
import { valueTransformer } from '../../utils/valueFormatter'
import { pillStyles } from '../utils'

export const StringRenderer = ({
  contentNode,
  isLoading,
}: { isLoading?: boolean; contentNode: ScalarContentNode } & BoxProps) => {
  const value = contentNode?.state?.asValue ?? contentNode.data
  const showSkeleton = !!isLoading
  const state = merge({}, contentNode.state)
  const { size, linkUrlStorage, linkUrl, _tooltip, textCase, styles } = state

  const capitalizeStyles: TextProps =
    textCase === 'all'
      ? { textTransform: 'uppercase' }
      : textCase === 'word'
        ? { textTransform: 'capitalize' }
        : {}

  // Extract styles object if it exists and is an object
  const customStyles = styles && typeof styles === 'object' ? styles : {}

  return (
    <ConditionalTooltip
      isDisabled={
        showSkeleton || value === undefined || value === null || value === '-'
      }
      tooltipOptions={_tooltip as any}
    >
      <ConditionalLink
        isDisabled={
          showSkeleton || value === undefined || value === null || value === '-'
        }
        to={linkUrl as any}
        search={linkUrlStorage as any}
      >
        <Text
          size={size}
          {...(linkUrl && pillStyles)}
          {...capitalizeStyles}
          {...customStyles}
        >
          <InlineSkeleton isLoading={showSkeleton}>
            {valueTransformer(value)}
          </InlineSkeleton>
        </Text>
      </ConditionalLink>
    </ConditionalTooltip>
  )
}
